import { Input } from "./Input";

interface SearchInputProps {
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
  className?: string;
  inputSize?: "sm" | "md" | "lg";
  "aria-label"?: string;
}

export function SearchInput({
  value,
  onChange,
  placeholder = "Buscar…",
  className = "",
  inputSize = "md",
  ...rest
}: SearchInputProps) {
  return (
    <Input
      icon="search"
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      hideWrapper
      inputSize={inputSize}
      className={className}
      aria-label={rest["aria-label"] ?? placeholder}
    />
  );
}
